import { CustomTooltip } from '@/components/Chart/components/CustomTooltip'
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  TooltipContentProps,
  XAxis,
  YAxis,
} from 'recharts'

import {
  calculateTickIndices,
  createTickFormatter,
  formatYAxisTick,
  getYAxisTicks,
} from './helpers'

export interface ChartDataItem {
  name: string
  tooltipLabel?: string
  value: number
  date: string
  index: number
}

interface ChartProps {
  data: ChartDataItem[]
  decimalPlaces?: number
  dateRange?: [Date, Date]
}

export const Chart = ({ data, decimalPlaces = 2 }: ChartProps) => {
  const firstYear = data.length ? new Date(data[0].date).getFullYear() : null
  const lastYear = data.length ? new Date(data[data.length - 1].date).getFullYear() : null
  const rightPadding = lastYear !== firstYear ? 16 : 10
  const yAxis = getYAxisTicks(data, 'value')

  return (
    <ResponsiveContainer width='100%' height='100%'>
      <LineChart data={data} margin={{ top: 8, right: 18 }}>
        <CartesianGrid stroke='#eee' strokeDasharray='5 5' horizontal={true} vertical={false} />
        <XAxis
          dataKey='index'
          type='number'
          domain={[0, data.length - 1]}
          tick={{ fontSize: 11 }}
          ticks={calculateTickIndices(data)}
          tickFormatter={createTickFormatter(data)}
          padding={{ left: 10, right: rightPadding }}
          interval={0}
        />
        <YAxis
          width='auto'
          domain={yAxis.domain}
          ticks={yAxis.ticks}
          interval={0}
          tickFormatter={(value) => formatYAxisTick(value, yAxis.ticks)}
          tick={{ fontSize: 11 }}
        />
        <Tooltip
          content={(props: TooltipContentProps<number, string>) => (
            <CustomTooltip decimalPlaces={decimalPlaces} {...props} />
          )}
        />
        <Line
          type='monotone'
          dataKey='value'
          stroke='#82ca9d'
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
